import React, { useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { motion } from "framer-motion";
import priceImg1 from "./priceImg1.png";
import { FaGlobe, FaTimesCircle, FaHeadset } from "react-icons/fa";
import { TiCancel } from "react-icons/ti";

const Section1 = () => {
  const text = "take action".split(" ");
  const colors = ["#1a1aff", "#7a00cc", "#2e5cb8", "#666699", "#9900e6"];
  const [colorIndex, setColorIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [colors.length]);

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        height: {
          xl: "500px",
          lg: "600px",
          md: "600px",
          sm: "600px",
        },
        backgroundImage: `url('Bg.svg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        // overflow: 'scroll',
        // p: 2,
      }}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: {
            xl: "row",
            lg: "row",
            md: "row",
            sm: "row",
            xs: "column",
          },
          justifyContent: "flex-start",
          alignItems: "center",
          width: { xs: "100%", sm: "90%", md: "80%", lg: "80%", xl: "70%" },
          marginBottom: { xl: "6%", lg: "16%", md: "24%", sm: "7%", xs: "7%" },
        }}
      >
        {/* First Stack with Text and Buttons */}
        <Stack
          sx={{
            height: "250px",
            // width: { xl: "70%", lg: "70%", md: "70%", sm: "70%", xs: "100%" },
            display: "flex",
            flexDirection: "column",
            justifyContent: {
              xl: "flex-start",
              lg: "flex-start",
              md: "flex-start",
              sm: "flex-start",
              xs: "flex-start",
            },
            alignItems: "center",
            marginTop: { xs: "2rem", sm: 0 },
            pl: { xl: "0px", lg: "0px", md: "18px", sm: "0px", xs: "30px" },
            // pr: { xs: "0%", xl: "25%", lg: "16%", md: "0%", sm: "0%" }
            width: { xs: '100%', lg: '70%' }
          }}
        >
          <Stack
            sx={{
              fontSize: {
                xs: "20px",
                sm: "24px",
                md: "24px",
                lg: "32px",
                xl: "32px",
              },
              fontWeight: {
                xs: "600",
                sm: "600",
                md: "600",
                lg: "600",
                xl: "600",
              },
              fontFamily: "'Roboto', sans-serif",
              color: "rgb(5, 78, 146)",
              lineHeight: {
                xs: "28px",
                sm: "36px",
                md: "32px",
                lg: "41px",
                xl: "41px",
              },
              //  pr: {xs: "0px", sm: "0px", md: "0px", lg: "0px", xl: "22%" }
              textAlign: 'left',
              width: '100%',
            }}
          >
            Unlock Powerful Automation with Budget-Friendly Solutions
          </Stack>

          <Stack
            display={{ md: "flex", xs: "none" }}
          >
            <Typography
              sx={{
                marginTop: "8px",
                lineHeight: { lg: '31px', xl: '31px', md: '20px', xs: '20px', sm: '20px' },
                fontSize: { lg: '21px', xl: '21px', md: '16px', xs: '16px', sm: '16px' },
                fontFamily: "'Roboto', sans-serif",
                fontWeight: { lg: 400, xl: 400, xs: 400, sm: 400 },
                color: '#333',
                textAlign: 'justify',
                // marginLeft: { lg: "30px", md: "0", sm: "20px"}
              }}
            >
              Effortlessly automate your daily operations to save valuable time, reduce costly errors, and increase overall productivity.
              With minimal overhead, you can scale your business faster and stay ahead of the competition—all without overspending.
            </Typography>
          </Stack>


          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              marginTop: "28px",
              gap: "20px",
              width: "100%",
              marginTop: { xl: "18px", lg: "18px", md: "0", sm: "0", xs: "18px" }
            }}
          >
            <Button
              variant="contained"
              startIcon={<FaGlobe size={14} />}
              sx={{
                backgroundColor: "rgb(5 78 146)",
                textTransform: "none",
                borderRadius: "8px",
                width: "fit-content",
                fontSize: { xl: "14px", lg: "14px", md: "12px", xs: "12px" },
                padding: {
                  xl: "8px 20px",
                  lg: "8px 20px",
                  md: "8px 20px",
                  xs: "6px 16px",
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "120px",
              }}
            >
              Free Trial
            </Button>
            <Button
              variant="contained"
              startIcon={<FaTimesCircle size={14} />}
              sx={{
                backgroundColor: "rgb(5 78 146)",
                textTransform: "none",
                borderRadius: "8px",
                width: "fit-content",
                fontSize: { xl: "14px", lg: "14px", md: "12px", xs: "12px" },
                padding: {
                  xl: "8px 20px",
                  lg: "8px 20px",
                  md: "8px 20px",
                  xs: "6px 16px",
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "120px",
              }}
            >
              Cancel Anytime
            </Button>
            <Button
              variant="contained"
              startIcon={<FaHeadset size={14} />}
              sx={{
                backgroundColor: "rgb(5 78 146)",
                textTransform: "none",
                borderRadius: "8px",
                width: "fit-content",
                fontSize: { xl: "14px", lg: "14px", md: "12px", xs: "12px" },
                padding: {
                  xl: "8px 20px",
                  lg: "8px 20px",
                  md: "8px 20px",
                  xs: "6px 16px",
                },
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                justifyContent: "center",
                minWidth: "120px",
              }}
            >
              Human Support
            </Button>
          </Stack>
        </Stack>

        {/* Second Stack with Image */}
        {/* <Stack
          sx={{
            // border: "1px solid red",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: {
              xl: "20px",
              lg: "20px",
              sm: "48px",
              xs: "20px"
            },
            marginTop: { xs: "-7.5rem", sm: "0" },
          }}
        >
          <img
            src={priceImg1}
            alt="Section Illustration"
            style={{
              width: "85%",
              height: "auto",
              objectFit: "cover",
            }}
          />
        </Stack> */}

        <Stack
          sx={{
            // border: "1px solid blue",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            width: { xs: '100%', md: '30%' },
            marginBottom: {
              xl: "12px",
              lg: "12px",
              md: "24px",
              sm: "48px",
              xs: "20px",
            },
            marginTop: {
              xs: "-7.5rem",
              sm: "0",
            },
            // paddingRight: { xs: "0", sm: "0", md: "0", lg: "0", xl: "6%" }
          }}
        >
          <Box
            component="img"
            src={priceImg1}
            alt="Section Illustration"
            sx={{
              width: {
                xs: "80%",
                sm: "80%",
                md: "90%",
                lg: "85%",
                xl: "85%",
              },
              height: "auto",
              objectFit: "cover",
            }}
          />
        </Stack>

      </Stack>
    </Stack>
  );
};

export default Section1;